const listStyle = {
  list: {
    color: "white",
    padding: "0 1rem",
    "@media (min-width: 400px)": {
      padding: "0 3rem",
    },
  },
  listRoot: {
    display: "flex-inline",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    padding: "8px",
    "&:empty": {
      display: "none",
    },
  },
  listHeadings: {
    fontWeight: "450",
    textAlign: "left",
  },
  listItems: {
    textAlign: "left",
    maxWidth: "600px",
    fontSize: "18px",
    "@media (min-width: 600px)": {
      fontSize: "20px",
    },
    lineHeight: "1.75rem",
  },
  listItemsMobile: {
    textAlign: "left",
    width: "100%",
    margin: "auto",
  },
  anchorClass: {
    color: "#50B6C5",
  },
  stickyButton: {
    display: "-webkit-flex",
    position: "sticky",
    bottom: "15px",
    right: "15px",
    justifyContent: "flex-end",
  },
};

export default listStyle;
